export default __webpack_public_path__ + "static/media/chevron.9d7ef774.svg";